import createErrorClass from '../create-error-class';
import errorCodeManager, { ErrorCodeType } from '../create-error-code';
import ErrorCodes from '@src/error/error-codes';

/**
 * "中断线程"异常
 * @type {{name, new(...[*]): CustomClass, constructor: *, __proto__, prototype: CustomClass}}
 */
const EndThreadError = createErrorClass('EndThreadError', errorCodeManager(ErrorCodes.EndThreadError, ErrorCodeType.OK), 'end current thread');
export default EndThreadError;
